<div class="fixed top-4 right-4 z-50 space-y-2">
  <div *ngFor="let toast of toasts"
    (click)="dismiss(toast.id)"
    class="px-4 py-3 rounded-lg shadow-lg cursor-pointer text-sm font-medium flex items-center space-x-2 min-w-[280px] animate-slide-in text-white"
    [ngClass]="{
      'bg-green-600': toast.type === 'success',
      'bg-red-600': toast.type === 'error',
      'bg-blue-600': toast.type === 'info'
    }">
    <svg *ngIf="toast.type === 'success'" class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
    </svg>
    <svg *ngIf="toast.type === 'error'" class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
    </svg>
    <svg *ngIf="toast.type === 'info'" class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
    <span>{{ toast.message }}</span>
  </div>
</div>
